import { useEffect } from "react";

const PreventPullToRefresh = () => {
    useEffect(() => {
        let startY = 0;

        const onTouchStart = (event) => {
            startY = event.touches[0].clientY;
        };

        const onTouchMove = (event) => {
            const currentY = event.touches[0].clientY;

            // If user is at the top and pulling down, prevent default behavior
            if (window.scrollY === 0 && currentY > startY) {
                event.preventDefault();
            }
        };

        document.addEventListener("touchstart", onTouchStart, { passive: true });
        document.addEventListener("touchmove", onTouchMove, { passive: false });

        return () => {
            document.removeEventListener("touchstart", onTouchStart);
            document.removeEventListener("touchmove", onTouchMove);
        };
    }, []);

    return null; // No UI needed, just handling events
};

export default PreventPullToRefresh;
